import { createFileRoute } from "@tanstack/react-router";
import RemindersAddPage from "@/site/pages/reminders-add";

// The ONE public "add birthdays" page (2026-09-28): the legacy logged-out landing
// (/reminders/add), the logged-in "Add New Reminders" page (this URL) and the post-import
// "get more birthdays" page (/reminders/birthday/more) merged — see the page for the
// rationale. Public: the __root guard allowlists it so a logged-out visitor sees the
// landing and its CTAs open the authwall in place.
interface RemindersAddSearch {
  /** Where the member landed from: `br` = just answered someone's birthday request
   *  (BrFunnel "All set!"), `import` = the importer just ran on this page. */
  from?: "br" | "import";
  /** `from=br`: the requester's first name for the congrats banner. */
  name?: string;
  /** `from=import`: counts for the banner. */
  imported?: number;
  requested?: number;
}

export const Route = createFileRoute("/reminders_/birthday_/add")({
  validateSearch: (search: Record<string, unknown>): RemindersAddSearch => {
    const out: RemindersAddSearch = {};
    if (search.from === "br" || search.from === "import") out.from = search.from;
    if (typeof search.name === "string" && search.name) out.name = search.name.slice(0, 60);
    if (typeof search.imported === "number") out.imported = search.imported;
    if (typeof search.requested === "number") out.requested = search.requested;
    return out;
  },
  component: RemindersAddPage,
});
